export const KEY_FEAGURE ='KEY_FEAGURE';
export const USER_SIGN_UP='USER_SIGN_UP';
export const TWITTER = 'TWITTER';
export const NEWS = 'NEWS';
export const STARTUPS = 'STARTUPS';